import { notification } from 'antd';
import axios from 'axios';
import store from '../store';
import { logoutAction } from 'store/auth/action';
const axiosInstance = axios.create();

export const setToken = token => {
  axiosInstance.defaults.headers.common['Authorization'] = `Bearer ${token}`;
};

export const removeToken = () => {
  delete axiosInstance.defaults.headers.common['Authorization'];
};

export const getLogoImage = (clientId = mobClientId) => {
  try {
    return `${baseUrl}/utility/file/public?key=file/public/clients/${clientId}/logo`;
  } catch (err) {
    console.log('getLogoImage', err);
  }
};

export const getLogoImageRedimed = (clientId = mobClientId) => {
  try {
    return `${baseUrl}/utility/file/public?key=file/public/clients/1/logo`;
  } catch (err) {
    console.log('getLogoImageRedimed', err);
  }
};

export const getSmallLogoImage = (clientId = mobClientId) => {
  try {
    return `${baseUrl}/utility/file/public?key=file/public/clients/${clientId}/logo_small`;
  } catch (err) {
    console.log('getSmallLogoImage', err);
  }
};

axiosInstance.interceptors.response.use(
  function(response) {
    // Do something with response data
    return response;
  },
  function(err) {
    console.log('Error', err);
    if (err.response && err.response.status === 401) {
      store.dispatch(logoutAction());
      return Promise.reject(err);
    }
    const unauthorizedMessage = `You don't have permission to perform this action,  please contact your administrator.`;
    if (err.response.status === 403) {
      return Promise.reject(new Error(unauthorizedMessage));
    }
    if (err.response && err.response.data && err.response.data.messages) {
      return Promise.reject(new Error(err.response.data.messages));
    }
    return Promise.reject(err);
  },
);

export default axiosInstance;

export const baseUrl = process.env.REACT_APP_BASE_URL;
export const utilityBaseUrl = process.env.REACT_APP_UTILITY_BASE_URL;
export const eformBaseUrl = process.env.REACT_APP_EFORM_BASE_URL;

export const mobClientId = process.env.REACT_APP_CLIENT_ID;
